'use client';

import { c as _c } from "react/compiler-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { JSX } from 'react';
import * as React from 'react';
import { cn } from '@/lib/utils';
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = t0 => {
  const $ = _c(12);
  let className;
  let props;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      sideOffset: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = t1;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    t1 = $[4];
  }
  const sideOffset = t1 === undefined ? 4 : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin] cursor-pointer", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== ref || $[9] !== sideOffset || $[10] !== t2) {
    t3 = <TooltipPrimitive.Portal><TooltipPrimitive.Content ref={ref} sideOffset={sideOffset} className={t2} {...props} /></TooltipPrimitive.Portal>;
    $[7] = props;
    $[8] = ref;
    $[9] = sideOffset;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
export const BetterTooltip = t0 => {
  const $ = _c(20);
  let children;
  let content;
  let contentClassName;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      content,
      children,
      align: t1,
      alignOffset: t2,
      contentClassName,
      side: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = content;
    $[3] = contentClassName;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    children = $[1];
    content = $[2];
    contentClassName = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  const align = t1 === undefined ? "center" : t1;
  const alignOffset = t2 === undefined ? 0 : t2;
  const side = t3 === undefined ? "top" : t3;
  let t4;
  if ($[8] !== children) {
    t4 = <TooltipTrigger asChild={true}>{children}</TooltipTrigger>;
    $[8] = children;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== align || $[11] !== alignOffset || $[12] !== content || $[13] !== contentClassName || $[14] !== side) {
    t5 = <TooltipContent align={align} alignOffset={alignOffset} className={contentClassName} side={side}>{content}</TooltipContent>;
    $[10] = align;
    $[11] = alignOffset;
    $[12] = content;
    $[13] = contentClassName;
    $[14] = side;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== props || $[17] !== t4 || $[18] !== t5) {
    t6 = <TooltipProvider delayDuration={100}><Tooltip {...props}>{t4}{t5}</Tooltip></TooltipProvider>;
    $[16] = props;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};